import React, {useSyncExternalStore} from 'react';
import {Spinner} from 'react-bootstrap';
import styled from 'styled-components';

type RoomStartupOverlayProps = {
    isRoomSceneReady: boolean;
    totalProductCount: number;
    subscribeToProductRenderProgress: (onProgress: () => void) => () => void;
    getRenderedProductCount: () => number;
};

const RoomStartupOverlay = ({
    isRoomSceneReady,
    totalProductCount,
    subscribeToProductRenderProgress,
    getRenderedProductCount,
}: RoomStartupOverlayProps) => {
    const renderedProductCount = useSyncExternalStore(
        subscribeToProductRenderProgress,
        getRenderedProductCount,
        getRenderedProductCount
    );
    const renderedProductPercent =
        totalProductCount > 0
            ? Math.round((renderedProductCount / totalProductCount) * 100)
            : 0;
    const showProductProgress = isRoomSceneReady && totalProductCount > 0;

    return (
        <Overlay>
            <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
            <h5>
                {isRoomSceneReady
                    ? 'Loading the products...'
                    : 'Creating your room...'}
            </h5>
            {showProductProgress ? (
                <>
                    <ProductProgressTrack>
                        <ProductProgressFill
                            style={{width: `${renderedProductPercent}%`}}
                        />
                    </ProductProgressTrack>
                    <p>
                        {renderedProductCount} of {totalProductCount} (
                        {renderedProductPercent}%)
                    </p>
                </>
            ) : null}
        </Overlay>
    );
};

const Overlay = styled.div`
    position: absolute;
    inset: 0;
    z-index: 200;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    background: #fff;
    text-align: center;

    p {
        margin: 0;
    }
`;

const ProductProgressTrack = styled.div`
    width: min(320px, 70%);
    height: 8px;
    border-radius: 999px;
    background: #e6e6e6;
    overflow: hidden;
`;

const ProductProgressFill = styled.div`
    height: 100%;
    border-radius: 999px;
    background: rgb(var(--primary_colour));
`;

export default RoomStartupOverlay;
